import { Offcanvas, Stack } from "react-bootstrap"
import { useShoppingCart } from "../context/ShoppingCartContext"
import { CartItem } from "./CartItem";
import React, { Fragment } from "react";
import { Button } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import CartTotals from "./CartTotals";

type ShoppingCartProps = {
  isOpen: boolean
}

export function Cart({ isOpen }: ShoppingCartProps) {
  const { closeCart, cartItems } = useShoppingCart()
  const location = useLocation();

  // Calculate subtotal (excluding STC items)
  const subtotal = cartItems.reduce((total, cartItem) => {
    if (cartItem.stockcode === 'WS-H-STC-ASSIGNED') {
      return total; // Don't add STC items to subtotal
    }
    return total + (cartItem?.price || 0) * cartItem.quantity
  }, 0)

  // Calculate rebate amount from STC items
  const rebateAmount = cartItems.reduce((total, cartItem) => {
    if (cartItem.stockcode === 'WS-H-STC-ASSIGNED') {
      return total + (cartItem.quantity * 35); // $35 per STC certificate
    }
    return total;
  }, 0)

  return (
    <Offcanvas show={isOpen} onHide={closeCart} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Cart</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Stack gap={3}>

          {cartItems.length === 0 ? (
            <p className="text-center">No products in your cart.<br />
              Add items at the <Link to="/products">products</Link> page.</p>
          ) :

            <Fragment>

              {cartItems.map(item => (
                <CartItem key={item.id} {...item} />
              ))}

              <div className="p-4">
                <CartTotals subtotal={subtotal} rebateAmount={rebateAmount} />
              </div>

              {location.pathname !== '/checkout' && <Button variant="contained" component={Link} to="/checkout" onClick={closeCart}>Proceed to Checkout</Button>}

            </Fragment>
          }

        </Stack>
      </Offcanvas.Body>
    </Offcanvas>
  );
}